export enum InputAction {
  Handshake = 'Handshake',
  GetDownloads = 'GetDownloads',
  DownloadStatus = 'DownloadStatus',
  GetAppSettings = 'GetAppSettings',
}


// Handshake
export type HandshakePayload = {
  uwpRequestTime: number
}
export type HandlerHandshake = (p: HandshakePayload) => void


// GetDownloads
// TODO: type GetDownloads
export type HandlerGetDownloads = (p: any) => void

// GetAppSettings
// TODO: type GetAppSettings
export type HandlerGetAppSettings = (p: any) => void

// DownloadStatus
export enum DownloadStatus {
  IDLE = 'IDLE',
  WAITING = 'WAITING',
  QUEUED = 'QUEUED',
  DOWNLOADING = 'DOWNLOADING',
  PAUSED = 'PAUSED',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED'
}
export type DownloadStatusPayload = {
  state: keyof typeof DownloadStatus
  progress: number
  titleId: string
}
export type HandlerDownloadStatus = (p: DownloadStatusPayload) => void

export type InputHandlers =
  | HandlerHandshake
  | HandlerGetDownloads
  | HandlerDownloadStatus
  | HandlerGetAppSettings

export type InputActions = keyof typeof InputAction
